import React from "react";
import {
  StarRatingSection,
  StarRating,
} from "../../styles/psl-performance-styles";
import halfPinkStar from "../../../shared/general/rating_img/halfPinkStar.png";
import fullPinkStar from "../../../shared/general/rating_img/fullPinkStar.png";
import greyStar from "../../../shared/general/rating_img/greyStar.png";
interface StarRatingProps {
  rating: number;
}

export const Rating: React.FC<StarRatingProps> = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <StarRatingSection>
      {Array.from({ length: fullStars }).map((_, index) => (
        <StarRating key={index} src={fullPinkStar} alt="Full star" />
      ))}
      {halfStar && <StarRating src={halfPinkStar} alt="Half star" />}
      {Array.from({ length: emptyStars }).map((_, index) => (
        <StarRating key={index} src={greyStar} alt="Empty star" />
      ))}
    </StarRatingSection>
  );
};
